import { Component, Input, ChangeDetectionStrategy, OnChanges, SimpleChanges } from '@angular/core';
import { ExpansionPanelData, Foaming } from '@usimweb/core/models';

@Component({
    selector: 'app-model',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './model.component.html',
    styleUrls: ['./model.component.scss'],
    standalone: false
})
export class ModelComponent implements OnChanges {
  @Input() foaming: any = {} as any;

  public data!: ExpansionPanelData[];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['foaming'] && this.foaming && this.foaming.meshStats) {
      this.data = [
        {
          title: 'Mold orientation',
          row: [
            {
              col: [
                { value: this.foaming.gravityX || 0, placeholder: 'Gravity X' },
                { value: this.foaming.gravityY || 0, placeholder: 'Gravity Y' },
                { value: this.foaming.gravityZ || 0, placeholder: 'Gravity Z' },
              ],
            },
          ],
        },
        {
          title: 'Mesh statistics',
          row: [
            {
              col: [
                { value: this.foaming.meshStats.numCells, placeholder: 'NumCells' },
                { value: this.foaming.meshStats.maxSurfaceRefinementLevel, placeholder: 'RefinementLevel' },
                { value: this.foaming.meshStats.volume, placeholder: 'Volume [m³]' },
                { value: this.foaming.meshStats.hCoarse, placeholder: 'Mesh size [mm]' },
              ],
            },
          ],
        },
      ];
    }
  }
}
